// @core/api/endpoints/project/clone_sprint.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CloneSprintRequest,
  SprintResponse,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Clone sprint
 * Creates a new sprint based on a completed sprint, carrying over incomplete items and applying the same duration. Useful for starting the next iteration.
 */
export async function CloneSprint(
  project_id: string,
  sprint_id: string,
  data: CloneSprintRequest,
  options?: RequestOptions
): Promise<SprintResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/sprints/:sprint_id/clone`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':sprint_id', encodeURIComponent(sprint_id));
  const requestOptions = options;
  return client.post<SprintResponse>(requestPath, data, requestOptions);
}
